import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { ASSET_LOST_TYPE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import LicenseForm from "./LicenseForm";
import AssetLostTypeForm from "./AssetLostTypeForm";

function AssetLostTypeDialog({
    assetLostTypeId: assetLostTypeId = "",
    assetLostTypeName: assetLostTypeName,
    variant = "button", // 'button' for add, 'link' for edit
    onSuccess,
}) {
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = async () => {
        if (assetLostTypeId && assetLostTypeId !== "") {
            setLoading(true);
            try {
                const response = await AxiosInstance.get(
                    `${ASSET_LOST_TYPE_URL}/${assetLostTypeId}`
                );
                setEditData(response.data);
                setOpen(true);
            } catch (error) {
                console.error("Error fetching Asset Lost Type data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setEditData(null);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditData(null);
    };

    const renderTrigger = () => {
        if (variant === "link" && assetLostTypeId) {
            return (
                <Link
                    component="button"
                    onClick={handleClickOpen}
                    disabled={loading}
                    sx={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "primary.main",
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    }}
                >
                    {assetLostTypeName}
                </Link>
            );
        }

        return (
            <Tooltip
                title="Asset Status"
                onClick={handleClickOpen}
                disabled={loading}
            >
                <IconButton
                    sx={{
                        cursor: "pointer",
                        margin: "2px",
                        color: (theme) => theme.palette.grey[500],
                        borderRadius: 2,
                        border: 1,
                        borderColor: "divider",
                    }}
                >
                    <AddTaskOutlinedIcon color="primary" />
                </IconButton>
            </Tooltip>
        );
    };

    return (
        <>
            {renderTrigger()}
            <AssetLostTypeForm
                open={open}
                onClose={handleClose}
                editData={editData}
                onSuccess={onSuccess}
                isEditMode={Boolean(editData)}
            />
        </>
    );
}
export default AssetLostTypeDialog;
